<template>
  <div class="modalDialog-backdrop">
    <div
      class="modalDialog"
      :style="{
        width: DialogWidth,
        height: DialogHeight,
        minWidth: DialogMinWidth
      }"
    >
      <header class="modalDialog-header align-middle">
        <div v-show="center"></div>
        <div style="margin-left: 5px; padding-top: 3px">{{ popName }}</div>
        <button
          type="button"
          class="btn-close"
          style="margin-right: 3px; padding-top: 6px"
          @click="close"
        ></button>
      </header>
      <div
        class="modalDialog-body-footer"
        :style="noscroll ? '' : 'overflow: auto'"
      >
        <section class="modalDialog-body">
          <slot name="body"> </slot>
        </section>

        <footer :class="mClass">
          <slot name="footer"> </slot>
        </footer>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ModalDialog',
  props: {
    popName: String,
    DialogWidth: String,
    DialogHeight: String,
    DialogMinWidth: String,
    center: Boolean,
    noscroll: Boolean,
    marginClass: String
  },
  data() {
    return {
      leftnum: false,
      mClass: 'modalDialog-footer'
    }
  },
  mounted() {
    this.mClass = this.mClass + ' ' + this.marginClass
    $('.modalDialog-backdrop').each(element => {
      var width = $('.modalDialog-backdrop')
        .eq(element)
        .find('.modalDialog')
        .css('width')
      if (width.indexOf('%') !== -1 && parseInt(width) > 50) {
        $('.modalDialog-backdrop').eq(element).addClass('width-active')
      }
      if (parseInt(width) > 900 && width.indexOf('px') !== -1) {
        $('.modalDialog-backdrop').eq(element).addClass('width-active')
      }
    })
  },
  methods: {
    close() {
      this.$emit('close')
    }
  }
}
</script>

<style></style>
